import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  FilledInput,
} from "@mui/material";
import { Box, styled } from "@mui/system";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import "../components/ToggleSidebar.css";
import FooterNew from "../../Home/components/Footer/FooterNew";
import Logo from "../Assets/Logo/logo2.svg";
import {
  useGetAdhocRanklistQuery,
  useGetWebsiteConfigQuery,
} from "../../app/services/userCore";

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <FilledInput
      variant="outlined"
      id="search"
      type="text"
      placeholder="Filter By Name/College"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      inputProps={{
        style: { color: "white", opacity: "0.7", fontSize: "0.9rem" },
      }}
    />
    <Button
      type="button"
      onClick={onClear}
      style={{ color: "white", opacity: "0.7" }}
    >
      X
    </Button>
  </>
);

const CardContentsMobile = styled(CardContent)({
  color: "#F4F4FF",
  padding: "2rem",
});

const customStyles = {
  headCells: {
    style: {
      fontSize: "1.2rem",
    },
  },
  cells: {
    style: {
      fontSize: "0.8rem",
    },
  },
};

const columns = [
  {
    name: "No.",
    selector: (row) => row.serialNumber,
    width: "5%",
  },
  {
    name: "Email",
    selector: (row) => row.email,
    width: "18%",
  },
  {
    name: "Name",
    selector: (row) => row.name,
    width: "20%",
  },
  {
    name: "College",
    selector: (row) => row.college,
  },
  {
    name: "Branch",
    selector: (row) => row.branch,
    width: "20%",
  },
  {
    name: "Score",
    selector: (row) => row.score,
    width: "10%",
  },
  {
    id: "percentage",
    name: "Percentage",
    selector: (row) => row.percentage,
    format: (row) => `${row.percentage}%`,
    sortable: true,
    omit: true,
  },
];

const Ranklist = () => {
  const [rankData, setRankData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { data: ranklistTitle } = useGetWebsiteConfigQuery({
    program: "knowYourPrep",
    key: "ranklistTitle",
  });
  const { data: ranklistSheet } = useGetWebsiteConfigQuery({
    program: "knowYourPrep",
    key: "ranklistSheet",
  });

  const { data, isFetching, isError, isSuccess, error } =
    useGetAdhocRanklistQuery(ranklistSheet?.value);

  useEffect(() => {
    if (isError) {
      try {
        toast.error(error.data.message, {
          toastId: "error",
        });
        console.log("Error in getRanklist -", error);
      } catch (err) {
        console.log(err);
        toast.error("Something went wrong! Contact admin.", {
          toastId: "networkError1",
        });
      }
    } else if (isSuccess) {
      const newData = data.data.map((row, index) => ({
        ...row,
        serialNumber: index + 1,
      }));
      setRankData(newData);
    }
  }, [error, isSuccess, isError]);

  const filteredItems = rankData.filter(
    (item) =>
      (item.name &&
        item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.college &&
        item.college.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.email &&
        item.email.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <div>
      <div>
        <div className="container-fluid mt-3 mb-3">
          <nav className="navbar navbar-expand-lg  shadow-md">
            <div className="container-fluid p-2">
              <div className="form-inline mr-auto">
                <Link className="navbar-brand text-primary mr-0" to="/">
                  <img
                    className="brand-logo"
                    src={Logo}
                    alt="O(1) Coding Club"
                    srcSet=""
                  />
                </Link>
              </div>
              <h3
                style={{
                  color: "white",
                  marginRight: "auto",
                  textTransform: "capitalize",
                  textAlign: "center",
                }}
              >
                Top Performers - {ranklistTitle?.value}
              </h3>
            </div>
          </nav>
        </div>

        <Container maxWidth="xl">
          <Grid container>
            <Grid item xs={12}>
              <Box>
                <Card
                  className="rankTable"
                  sx={{
                    boxShadow: 2,
                    minWidth: 275,
                    backgroundColor: "#10153B",
                  }}
                >
                  <CardContentsMobile>
                    <DataTable
                      columns={columns}
                      data={filteredItems}
                      defaultSortFieldId={"percentage"}
                      defaultSortAsc={false}
                      customStyles={customStyles}
                      theme="solarized"
                      pagination
                      paginationComponentOptions={{ selectAllRowsItem: true }}
                      fixedHeader
                      actions={subHeaderComponentMemo}
                    />
                  </CardContentsMobile>
                </Card>
              </Box>
            </Grid>
          </Grid>

          <FooterNew />
        </Container>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        pauseOnHover
      />
    </div>
  );
};

export default Ranklist;
